import React from 'react';
import { Form, Button, Spinner } from 'react-bootstrap';

const RegisterOtpVerifyForm = ({
  email,
  otp,
  setOtp,
  handleVerifyOtp,
  setStep,
  loading
}) => {
  return (
    <Form onSubmit={handleVerifyOtp}>
      <p className="text-white small mb-3 text-center">Enter the 6-digit code sent to <b>{email}</b>.</p>
      <Form.Control 
        type="text" 
        placeholder="------" 
        value={otp} 
        onChange={(e) => setOtp(e.target.value.replace(/\D/g, '').slice(0,6))} 
        maxLength="6"
        className="form-ctrl-login-custom text-center mb-4" 
        style={{ letterSpacing: '0.5em', fontSize: '1.5rem' }}
      />
      <Button type="submit" className="btn-auth-primary w-100" disabled={loading}>
        {loading ? (
          <>
            <Spinner size="sm" animation="border" />
            <span>VERIFYING...</span>
          </>
        ) : (
          'Verify & Complete'
        )}
      </Button>
      <div className="text-center mt-3">
        <Button variant="link" className="text-white small p-0 text-decoration-none" onClick={() => setStep(1)}>
          &larr; Edit details / Back
        </Button>
      </div>
    </Form>
  );
};

export default RegisterOtpVerifyForm;
